import { consoleMsg, waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { devModePhotosValidation } from "../shared/app-data";
import { inspectionMgr } from "../web-components";
import { previous } from "../shared/navigation";
import { renderNavButtons } from "../shared/templates.js";

const app = window.app;
const storageKey = app.state.storageKey;

export class Photos extends HTMLElement {
	async connectedCallback() {
		// Make sure detailsContent is available before attempting to inject HTML
		await waitForContent("photos");

		// Now we're sure HTML content is ready to inject
		this.innerHTML = app.content.photos;

		// Render the navigation buttons component
		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton9", "nextButton9"));

		this.addEventListener("ionViewWillEnter", async () => {
			/* NOTE: This page was added late in the project after other pages and application logic was complete.  Even though it appears 
         earlier in app logic flow, it is assigned a page number of 10.  REVISIT THIS AND FIX ONCE COMPLETE CHANGES NEEDED TO SIGNATURE 
         PAGE VALIDATION LOGIC!!*/
			const pageElement = this;
			await initializePage(9, pageElement);
		});

		this.addEventListener("ionViewDidEnter", async () => {
			await devModePhotosValidation();

			// Photo action-sheet handlers
			inspectionMgr.attachPhotoEventListeners(this);

			// Restore photos from storage
			await inspectionMgr.restoreAllPhotos();

			// Ensure UI reflects updated photos
			inspectionMgr.updatePhotoUI();

			// Next/previous come from the flow manager — no vendor/direction logic needed.
			const currentRoute = app.routes.photos;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));
		});
	}
}
